<template>

    <div class="row-wrapper col">
        <div class="bg-hvr"></div>
        <div class="head">
            <div class="row-title">
                <h5 class="txt-grt">{{ row.name }}</h5>
                <div class="edit" @click.prevent="edit">
                    <span class="ico">
                        <svg width="20" height="21" viewBox="0 0 20 21" fill="none">
                        <path d="M13.8596 1.69706C14.4536 1.10303 14.7506 0.806018 15.0931 0.694736C15.3944 0.596849 15.7189 0.596849 16.0202 0.694736C16.3627 0.806018 16.6597 1.10303 17.2537 1.69706L17.3951 1.83848C17.9891 2.4325 18.2862 2.72952 18.3974 3.07201C18.4953 3.37327 18.4953 3.69779 18.3974 3.99906C18.2862 4.34155 17.9891 4.63856 17.3951 5.23259L9.05126 13.5764C8.85325 13.7745 8.75425 13.8735 8.64008 13.9106C8.53966 13.9432 8.43149 13.9432 8.33106 13.9106C8.2169 13.8735 8.1179 13.7745 7.91989 13.5764L5.51572 11.1723C5.31772 10.9743 5.21871 10.8753 5.18162 10.7611C5.14899 10.6607 5.14899 10.5525 5.18162 10.4521C5.21871 10.3379 5.31772 10.2389 5.51572 10.0409L13.8596 1.69706Z" fill="white"/>
                        <path d="M6.15637 14.6411L4.45143 12.9362C4.14836 12.6331 3.99682 12.4816 3.84173 12.4541C3.7063 12.4302 3.56698 12.4631 3.45656 12.5451C3.33011 12.639 3.26234 12.8423 3.1268 13.2489L2.52731 15.0473C2.28304 15.7802 2.1609 16.1466 2.24779 16.3902C2.3234 16.6023 2.49027 16.7691 2.70231 16.8447C2.94597 16.9316 3.31238 16.8095 4.04521 16.5652L5.84367 15.9657C6.25028 15.8302 6.45359 15.7624 6.54748 15.636C6.62948 15.5256 6.66236 15.3862 6.63841 15.2508C6.61098 15.0957 6.45944 14.9442 6.15637 14.6411Z" fill="white"/>
                        <rect x="1" y="19" width="19" height="2" rx="1" fill="white"/>
                        </svg>
                    </span>
                </div>
            </div>
            <div class="edit-hvr">
                <div class="infos">
                    <div class="row-type">
                        <span class="ico">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8596 1.12132C12.688 -0.0502522 10.7885 -0.0502527 9.61696 1.12132L1.88904 8.84924C1.13889 9.59939 0.717465 10.6168 0.717465 11.6777L0.717464 16.2132C0.717464 17.8701 2.06061 19.2132 3.71746 19.2132L8.253 19.2132C9.31386 19.2132 10.3313 18.7918 11.0814 18.0416L18.8093 10.3137C19.9809 9.14214 19.9809 7.24264 18.8093 6.07107L13.8596 1.12132ZM4.83879 15.0919C5.8151 16.0682 7.39801 16.0682 8.37432 15.0919C9.35063 14.1156 9.35063 12.5327 8.37432 11.5563C7.39801 10.58 5.8151 10.58 4.83879 11.5563C3.86248 12.5327 3.86248 14.1156 4.83879 15.0919Z" fill="white"/>
                            </svg>
                        </span>
                        <span class="txt ft-bld">{{rowType}} row ({{totalChildren}})</span>
                    </div>
                    <div class="sqr del" @click.prevent="toggleDel">
                        <span class="ico">
                            <svg width="18" height="19" viewBox="0 0 18 19" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M13 2H16.5C17.3284 2 18 2.67157 18 3.5C18 4.32843 17.3284 5 16.5 5H16V16C16 17.6569 14.6569 19 13 19H5C3.34315 19 2 17.6569 2 16V5H1.5C0.671573 5 0 4.32843 0 3.5C0 2.67157 0.671573 2 1.5 2H5C5 0.895431 5.89543 0 7 0H11C12.1046 0 13 0.895431 13 2ZM5 14.5C5 15.3284 5.67157 16 6.5 16C7.32843 16 8 15.3284 8 14.5V8.5C8 7.67157 7.32843 7 6.5 7C5.67157 7 5 7.67157 5 8.5V14.5ZM11.5 16C10.6716 16 10 15.3284 10 14.5V8.5C10 7.67157 10.6716 7 11.5 7C12.3284 7 13 7.67157 13 8.5V14.5C13 15.3284 12.3284 16 11.5 16Z" fill="white"/>
                            </svg>
                        </span>
                    </div>
                </div>

                <div class="pos">
                    <div class="sqr up" @click.prevent="rowUp">
                        <span class="ico">
                            <svg width="17" height="11" viewBox="0 0 17 11" fill="none">
                                <path d="M2 9L8.5 3L15 9" stroke="white" stroke-width="3"/>
                            </svg>
                        </span>
                    </div>
                    <div class="sqr dwn" @click.prevent="rowDown">
                        <span class="ico">
                            <svg width="17" height="11" viewBox="0 0 17 11" fill="none">
                                <path d="M15 2L8.5 8L2 2" stroke="white" stroke-width="3"/>
                            </svg>
                        </span>
                    </div>
                </div>

            </div>
        </div>
        <div class="row-outer">
            <div class="nv bw" v-show="currentPos > 0" @click.prevent="prv">
                <span class="ico">
                    <svg width="17" height="40" viewBox="0 0 17 40" fill="none">
                        <path d="M15 38L2.42285 20.5855C2.17042 20.236 2.17043 19.764 2.42285 19.4145L15 2" stroke="white" stroke-width="4" stroke-linejoin="round"/>
                    </svg>
                </span>
            </div>
            <div class="row-inner" ref="inner" :style="{ transform: 'translateX(' + -currentPos * 34 + '%)' }">
                <slot></slot>
            </div>
            <div class="nv fw" v-show="totalChildren > 3 && currentPos < (totalChildren - 3)" @click.prevent="nxt">
                <span class="ico">
                    <svg width="17" height="40" viewBox="0 0 17 40" fill="none">
                        <path d="M2 2L14.5771 19.4145C14.8296 19.764 14.8296 20.236 14.5771 20.5855L2 38" stroke="white" stroke-width="4" stroke-linejoin="round"/>
                    </svg>
                </span>
            </div>
        </div>
    </div>

</template>

<script>

    import Global from '../lib/GlobalState'

    export default {

        name: 'ContentRow',

        props: {
            row: {
                type: Object,
                default: () => ({})
            }
        },

        data() {
            return {
                Global,
                totalChildren: null,
                currentPos: 0,
            }
        },

        watch: {
            row(to) {
                if(this.totalChildren != to.assets.length) {
                    this.totalChildren = to.assets.length
                    this.currentPos = 0
                }
            }
        },
        
        computed: {
            totalHidden() {
                return this.totalChildren - 3
            },
            rowType() {
                return this.row.type.charAt(0).toUpperCase() + this.row.type.slice(1)
            }
        },
        
        mounted() {
            this.init()
        },

        methods: {

            init() {
                this.totalChildren = this.$children.length
            },

            prv() {
                let oldPos = this.currentPos
                if(this.currentPos >= 3){
                    this.currentPos = this.currentPos - 3

                }else{
                    this.currentPos = this.currentPos - oldPos
                }


            },

            nxt() {
                let oldPos = this.currentPos
                if(this.currentPos + 3 < this.totalHidden){
                    this.currentPos = this.currentPos + 3

                }else{
                    this.currentPos = this.currentPos + (this.totalHidden - oldPos)
                }

            },

            toggleDel() {
                this.Global.rowIdToDelete = this.row.id
                this.Global.tempClosingOverlay = false
                this.Global.activeBlurredOverlay = true
                this.Global.activeDelRowOverlay = true
            },

            rowUp() {
                const row = Object.assign({}, this.row)
                if(this.row.index <= 0) return

                row.assets = row.assets.map((asset) => {
                    return asset.index
                })

                this.Global.rows.splice(row.index, 1)
                this.Global.rows.splice(row.index - 1, 0, row)
            },
 
            rowDown() {

                const row = Object.assign({}, this.row)
                if(row.index >= this.Global.rows.length - 1) return
                
                row.assets = row.assets.map((asset) => {
                    return asset.index
                })
                
                this.Global.rows.splice(row.index, 1)
                this.Global.rows.splice(row.index + 1, 0, row)
            },

            edit() {
                this.Global.rowIdToEdit = this.row.id
                this.Global.tempClosingOverlay = false
                this.Global.activeBlurredOverlay = true
                this.Global.activeRowOverlay = true
            }

        }
    }
</script>